module.exports = __webpack_public_path__ + "img/next-loot-1.ebcbe6b8.png";